import React, { useState, useEffect, useRef, useMemo } from 'react';
import { ShoppingCart, Plus, Package, Users, LayoutGrid, Trash2, X, Search, Camera, Receipt, Save,
  Minus, Image as ImageIcon, BarChart3, Settings, Printer, Clock, ArrowUpRight, Edit3,
  FileText, Download, AlertTriangle, Ban, UserCheck, Share2, Copy, AlertOctagon, RefreshCw, Truck,
  RotateCcw, ChevronLeft, ChevronRight, ScanBarcode, UserCircle2, Layers, Lock, LogIn, Menu, LogOut,
  HelpCircle, CheckSquare, Square, MapPin, Phone, PauseCircle, PlayCircle, AlertCircle, Banknote,
  CreditCard, Smartphone, BookOpen, Crown, Unlock, Globe, Wallet, History, FileCheck, Boxes, PenLine,
  CreditCard as CardIcon, Store, ArrowRightLeft, UserCog, Briefcase, FileOutput, Megaphone, UserPlus,
  Link, MonitorSmartphone, Contact, FileMinus } from 'lucide-react';
import { apiCall, generateId, formatPrice, formatDate, compressImage,
  base64ToFile, printHtmlDiv, printRawHtml, printBarcodeDiv } from '../utils/utils.js';

// --- ERROR BOUNDARY ---
class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { hasError: false, error: null }; }
  static getDerivedStateFromError(error) { return { hasError: true, error }; }
  render() {
    if (this.state.hasError) return (
        <div className="h-screen w-screen flex items-center justify-center bg-[#f6f7f8] p-4">
            <div className="bg-white p-8 rounded-xl shadow-lg border border-[#e1e3e5] text-center">
                <AlertTriangle size={48} className="mx-auto text-[#d82c0d] mb-4"/>
                <h1 className="text-xl font-bold mb-2">React Error</h1>
                <div className="bg-[#1a1a1a] text-[#ff7373] p-4 rounded-lg text-xs overflow-x-auto text-left mb-4">{this.state.error.toString()}</div>
                <button onClick={() => window.location.reload()} className="bg-[#008060] text-white px-6 py-3 rounded-lg font-bold">Reload</button>
            </div>
        </div>
    );
    return this.props.children;
  }
}

export default ErrorBoundary;
